// @flow
import React from 'react';
import gql from 'graphql-tag';
import {
    GlobalBanner,
    globalBannerFragments
} from '@homeaway/react-global-messaging';
import {EdapProvider} from '@homeaway/react-event-tracking';
import withLingua from '../withLingua/withLingua';
import type {LinguaProps} from '../withLingua/withLingua';

type GlobalMessagesProps = {
    globalMessages?: mixed
};
type Props = GlobalMessagesProps & LinguaProps;

export const fragments = {
    SearchResult: gql`
        fragment GlobalBannerContainerSearchResult on SearchResult {
            globalMessages {
                ...GlobalBannerGlobalMessages
            }
        }
        ${globalBannerFragments.GlobalMessages}
    `
};

const ConnectedGlobalBanner = ({messages, globalMessages}: Props) => {
    const labels = {
        close: messages['shared.globalMessaging.close']
    };
    return globalMessages ? (
        <EdapProvider>
            <GlobalBanner globalMessages={globalMessages} labels={labels} />
        </EdapProvider>
    ) : null;
};

export default withLingua({
    namespace: 'ui-development/shared',
    category: 'globalMessaging'
})(ConnectedGlobalBanner);
